/**
 * Shared, dependency-light coach helpers used by both SSR adapters and client
 * components so the same IS1 mapping/validity rules live in one place.
 */

/**
 * Maps a raw IS1 gender value (e.g. `M` / `F` / `Ž` / `Z`) to our neutral
 * 'male' | 'female'. Returns undefined for empty/unknown input so callers can
 * decide their own fallback.
 */
export const mapIs1GenderRaw = (
    raw?: string | null
): 'male' | 'female' | undefined => {
    const g = (raw ?? '').trim().toUpperCase();
    if (!g) {
        return undefined;
    }
    return g === 'F' || g === 'Ž' || g === 'Z' ? 'female' : 'male';
};

/**
 * A coach licence counts as active when it has no `valid_to`, an unparsable
 * `valid_to`, or a `valid_to` that has not passed yet.
 */
export const isCoachLicenceActive = (
    validTo: string | null | undefined
): boolean => {
    if (!validTo) {
        return true;
    }
    const ts = Date.parse(validTo);
    return Number.isNaN(ts) || ts >= Date.now();
};
